import { gcloudStorageApi } from 'lib/api/client'
import { GetRunsRequest, GetRunsResponse } from './runs.types'

export const getRuns = async (
  request?: GetRunsRequest
): Promise<GetRunsResponse> => {
  const { data } = await gcloudStorageApi.get<GetRunsResponse>('/runs', {
    params: request,
  })

  return data
}
